import type * as MicrosoftTeams from '@microsoft/teams-js';

export type TeamsTabSdk = {
  app: Pick<typeof MicrosoftTeams.app, 'initialize' | 'getContext'>;
  pages: Pick<typeof MicrosoftTeams.pages, 'getConfig'>;
};

type TeamsTabHandlers = { onContentUrl: (path: string) => void; onThemeChange: (isDark: boolean) => void };

/** Arranca el SDK de Teams y avisa del tema y de la ruta de la pestaña. Nunca rechaza. */
export function loadTeamsTabSettings(microsoftTeams: TeamsTabSdk, { onContentUrl, onThemeChange }: TeamsTabHandlers): Promise<void> {
  return microsoftTeams.app
    .initialize()
    .then(() =>
      Promise.all([
        microsoftTeams.app.getContext().then((context) => {
          onThemeChange(context.app.theme === 'dark');
        }),
        microsoftTeams.pages.getConfig().then((pageConfig) => {
          if (pageConfig.contentUrl) {
            onContentUrl(pageConfig.contentUrl.replace(globalThis.location.origin, ''));
          }
        }),
      ])
    )
    .then(() => undefined)
    .catch(() => {
      // `isTeams()` mira window.name y el iframe, no si el cliente responde: fuera de él el SDK
      // rechaza a los 60 s (TANGERINE-FRONTOFFICE-55W) y la app sigue con el tema claro y su ruta.
    });
}
